<app-menu>
    <div class="header">
        <div class="header-title">
            <div class="title">Store Report</div>
            <div class="other-pages">
                <!-- styles are inline because of specificity issues when using classes with Angular Material properties-->
                <button mat-raised-button (click)="openExceptionReports()" style="background-color:rgb(2, 71, 10);color:white;margin-right:20px">Exception Reports</button>
                <button mat-raised-button (click)="openDeliveryReports()" style="background-color:rgb(2, 71, 10);color:white">Delivery Reports</button>
            </div>
        </div>
        <div class="header-btns">
            <div>
                <!-- styles are inline because of specificity issues when using classes with mat-raised-button property-->
                <button (click)="exportToCSV()" mat-raised-button style="background-color:rgb(2, 71, 10);color: white;margin-right:10px">Export to CSV</button>
                <button (click)="exportToExcel()" mat-raised-button style="background-color:rgb(2, 71, 10);color: white;">Export to Excel</button>
            </div>
            <button (click)="toggleTheme()" class="header-btn toggle-grid-mode-btn">
                <mat-icon>{{theme === 'ag-theme-ulaap' ? 'nights_stay' : 'wb_sunny'}}</mat-icon>
            </button>
        </div>
    </div>
  <ag-grid-angular
  *ngIf="gridReady"
  #agGrid style="width: 100%; height: 100%;" 
  class="ag-theme-balham" 
  [rowModelType]="rowModelType"
  [cacheBlockSize]="cacheBlockSize"
  [cacheOverflowSize]="cacheOverflowSize"
  [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
  [class]="theme"
  [gridOptions]="gridOptions"
  [rowData]="rowData"
  (gridReady)="onGridReady($event)"
  [defaultColDef]="defaultColDef"
  [columnDefs]="columnDefs"
  [initialState]="initialState"
  (stateUpdated)="onStateUpdated($event)"
  >
  </ag-grid-angular>
</app-menu>
<app-lading-status-modal *ngIf="isStatusModalOpen" (closeModal)="closeStatusModal($event)"
    [lading_uuid]="lading_uuid"></app-lading-status-modal>